/**
 * Returns the full URL with https prefix. If the URL already has a prefix, it will be returned as is.
 * @param fullUrl
 * @returns {string}
 */
export function getFullUrl(fullUrl) {
  let url = fullUrl;
  if (!fullUrl) {
    return '';
  }

  if (url.startsWith('http://') || url.startsWith('https://')) {
    return `${url}`;
  }
  url = `https://${url}`;
  return url;
}
